var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNearshoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outsourcing",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outsourcing_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.4,97.8L138.4,97.8c-0.8-2-2.9-3-4.9-2.5l-8.6,2l-1.4-4.3c-4.7-14.8-16.4-26.4-25.4-32.1 c-0.3-10.6-5.4-20.4-13.7-26.2l-4.1-2.9l-5.9,18.1c-2.4-2.9-6.2-6.1-12.2-8.5l-4.7-1.9l-0.5,5c0,0.5-4.3,47.9-17.9,63.1 c-1.3,1.5-1.5,3.6-0.5,5.3c1,1.7,3,2.5,4.9,2l10.3-2.6l-0.8,2.3l-19.2,4.6l1.7,7.2l83.4-19.9c-9.4,7.6-15.4,14.5-15.7,14.9 l-1.3,1.5l5.6,4.8l1.3-1.5c0.1-0.1,11.7-13.5,27.7-23.1C138.5,102,139.3,99.8,138.4,97.8z M97.4,93L98,69.9 c6.1,4.8,12.9,12.2,16.9,21.1L97.4,93z M61.7,112.1L84,44.2c4.5,4.9,6.9,11.6,6.7,18.8L89,105.8L61.7,112.1z M71,58.9l-14.5,45 l-7.1,1.8c9-16.1,13-43.3,14.5-55.2C69.1,53.8,70.6,57.4,71,58.9z M124.7,97.4l-28.1,6.7l0.1-3.6L124.7,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,127.6c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C38.5,129.7,36.3,127.6,33.7,127.6z M33,132.3c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v1.9c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7 V132.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 127.7,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6,
    y: 127.7,
    className: "st0",
    width: 4.1,
    height: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.7,127.6c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8s4.8-2.1,4.8-4.8v-1.9 C74.5,129.8,72.4,127.6,69.7,127.6z M70.4,132.4v1.9c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-1.9c0-0.4,0.3-0.7,0.7-0.7 S70.4,132,70.4,132.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.1,
    y: 127.8,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.6,
    y: 127.8,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80,127.6c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C84.8,129.8,82.6,127.6,80,127.6z M80.7,132.4v1.9c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-1.9c0-0.4,0.3-0.7,0.7-0.7 C80.4,131.7,80.7,132,80.7,132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.9,127.7c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C100.6,129.8,98.5,127.7,95.9,127.7z M96.6,132.4v1.9c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-1.9c0-0.4,0.3-0.7,0.7-0.7 C96.3,131.7,96.6,132,96.6,132.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.2,
    y: 127.8,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.7,
    y: 127.8,
    className: "st0",
    width: 4.1,
    height: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.9,127.7c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C136.6,129.9,134.5,127.7,131.9,127.7z M132.6,132.5v1.9c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v-1.9c0-0.4,0.3-0.7,0.7-0.7 S132.6,132.1,132.6,132.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.2,
    y: 127.9,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.7,
    y: 127.9,
    className: "st0",
    width: 4.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.2,127.7c-2.6,0-4.8,2.1-4.8,4.8v1.9c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8v-1.9 C146.9,129.9,144.8,127.7,142.2,127.7z M142.9,132.5v1.9c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v-1.9c0-0.4,0.3-0.7,0.7-0.7 C142.5,131.8,142.9,132.1,142.9,132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,81.1c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.7-0.4-1.1-0.5s-0.7-0.3-1.1-0.4c-0.3-0.1-0.6-0.2-0.8-0.3 c-0.2-0.1-0.3-0.2-0.4-0.3c0,0,0,0,0-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.2-0.1c0.2-0.1,1-0.1,1.4,0 c0.3,0.1,0.5,0.2,0.8,0.3c0.2,0.1,0.4,0.2,0.5,0.3c0.6,0.3,1,0.3,1.3,0.1c0.2-0.1,0.4-0.3,0.5-0.6c0-0.1,0.1-0.3,0.1-0.5 s0-0.4,0-0.6s0-0.4,0-0.6s0-0.3-0.1-0.4c0-0.2-0.1-0.3-0.1-0.4c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1-0.1-0.3-0.2-0.5-0.3 c-0.2-0.1-0.5-0.2-0.8-0.3L83,74.4c-0.5-0.1-1.2-0.2-2.5-0.2c-0.5,0-1,0.1-1.4,0.3c-0.7,0.2-1.3,0.5-1.7,0.9 c-0.5,0.4-0.9,0.9-1.1,1.5c-0.3,0.6-0.4,1.2-0.4,1.8c0,0.6,0.1,1.2,0.3,1.7c0.2,0.5,0.5,0.9,0.8,1.2c0.3,0.3,0.7,0.6,1.1,0.8 c0.4,0.2,0.7,0.4,1.1,0.5c0.4,0.2,0.7,0.3,1.1,0.4c0.3,0.1,0.6,0.2,0.8,0.3c0.2,0.1,0.3,0.2,0.4,0.3c0,0,0,0.1,0,0.2s0,0.2,0,0.2 c0,0.1-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.1-1.1,0.1-1.6-0.1c-0.3-0.1-0.6-0.2-0.9-0.3c-0.3-0.1-0.5-0.2-0.6-0.3 c-0.6-0.3-1-0.3-1.4-0.1c-0.2,0.1-0.4,0.3-0.5,0.6c-0.1,0.1-0.1,0.3-0.1,0.6c0,0.2,0,0.4,0,0.7c0,0.2,0,0.3,0,0.5 c0,0.5,0.1,1.1,0.5,1.4c1.1,0.8,2.3,1.1,4.5,1.1c0.2,0,0.3,0,0.5,0c0.4,0,0.8-0.1,1.2-0.2c0.7-0.2,1.3-0.5,1.8-0.9s1-0.9,1.3-1.5 s0.4-1.3,0.4-2.1c0-0.6-0.1-1.2-0.3-1.7C85.6,81.9,85.3,81.4,85,81.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearshoring);
export default __webpack_public_path__ + "static/media/nearshoring.6cacef605ac5e3468e478b12fb6985a3.svg";
export { ForwardRef as ReactComponent };